const SHANGHAI_TZ = 'Asia/Shanghai';

const SHANGHAI_DATE_TIME_FORMATTER = new Intl.DateTimeFormat('zh-CN', {
  timeZone: SHANGHAI_TZ,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

export const formatShanghaiDateTime = (value, fallback = '-') => {
  if (value === null || value === undefined || value === '') return fallback;
  const raw = String(value).trim();
  if (!raw) return fallback;
  const normalized = raw.replace(/(\.\d{3})\d+(Z|[+-]\d{2}:\d{2})$/, '$1$2');
  const dt = new Date(normalized);
  if (Number.isNaN(dt.getTime())) return raw;

  const parts = SHANGHAI_DATE_TIME_FORMATTER.formatToParts(dt);
  const map = {};
  parts.forEach((p) => {
    map[p.type] = p.value;
  });
  return `${map.year}-${map.month}-${map.day} ${map.hour}:${map.minute}:${map.second}`;
};

